import { JsonObject, JsonProperty } from 'json2typescript';
import BenefitsResource from '@/models/exam/BenefitsResource';
import Fee from '@/models/rank/Fee';

/**
 * 試験詳細画面用 検定ランク情報保持クラス
 */
@JsonObject('ExamRankDetail')
export default class ExamRankDetail {
  constructor() {
    this.examRankCode = undefined;
    this.examRankTitle = undefined;
    this.overview = undefined;
    this.timeLimit = undefined;
    this.notificationLimit = undefined;
    this.numberOfQuestions = undefined;
    this.passThreshold = undefined;
    this.questionMethod = undefined;
    this.examFeeType = undefined;
    this.judgmentType = undefined;
    this.possibleConditionsCount = undefined;
    this.canRetakeAfterPassing = undefined;
    this.existLimit = undefined;
    this.possibleExamCount = undefined;
    this.canPause = undefined;
    this.examinationPeriodStart = undefined;
    this.examinationPeriodEnd = undefined;
    this.requestPeriodStart = undefined;
    this.requestPeriodEnd = undefined;
    this.isStarting = undefined;
    this.isAccepting = undefined;
    this.registrationRequired = true;
    this.fees = new Array<Fee>();
    this.resources = undefined;
    this.benefits = new Array<BenefitsResource>();
    this.thumbnail = undefined;
    this.alternativeText = undefined;
    this.feeText = '';
  }

  @JsonProperty('exam_rank_code')
  public examRankCode?: string;

  @JsonProperty('exam_rank_title')
  public examRankTitle?: string;

  @JsonProperty('overview')
  public overview?: string;

  @JsonProperty('time_limit')
  public timeLimit?: number;

  @JsonProperty('notification_limit')
  public notificationLimit?: number;

  @JsonProperty('number_of_questions')
  public numberOfQuestions?: number;

  @JsonProperty('pass_threshold')
  public passThreshold?: number;

  @JsonProperty('question_method')
  public questionMethod?: string;

  @JsonProperty('exam_fee_type')
  public examFeeType?: string;

  @JsonProperty('judgment_type')
  public judgmentType?: string;

  @JsonProperty('possible_conditions_count')
  public possibleConditionsCount?: number;

  @JsonProperty('can_retake_after_passing')
  public canRetakeAfterPassing?: boolean;

  @JsonProperty('exist_limit')
  public existLimit?: boolean;

  @JsonProperty('possible_exam_count')
  public possibleExamCount?: number

  @JsonProperty('can_pause')
  public canPause?: boolean;

  @JsonProperty('examination_period_start')
  public examinationPeriodStart?: string;

  @JsonProperty('examination_period_end')
  public examinationPeriodEnd?: string;

  @JsonProperty('request_period_start')
  public requestPeriodStart?: string;

  @JsonProperty('request_period_end')
  public requestPeriodEnd?: string;

  @JsonProperty('is_starting')
  public isStarting?: boolean;

  @JsonProperty('is_accepting')
  public isAccepting?: boolean;

  @JsonProperty('registration_required')
  public registrationRequired?: boolean;

  @JsonProperty('fees')
  public fees: Array<Fee>;

  @JsonProperty('resources')
  public resources?: object[] = [];

  @JsonProperty('benefits')
  public benefits: Array<BenefitsResource>;

  public thumbnail?: string;

  public alternativeText?: string;

  public feeText: string;
}
